module.exports = ".subcategories-of-category-product + .subcategories-of-category-product,\n.categories-of-product + .categories-of-product {\n  border-top: 1px solid rgba(0, 0, 0, 0.125);\n  padding-top: 20px;\n  margin-top: 20px; }\n\nng-select {\n  margin: 5px 0; }\n\n.ladda-button {\n  padding: .375rem 1.6rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/settings/settings.component.scss
// module id = ./src/app/pages/settings/settings.component.scss
// module chunks = main